
    var riot = require('riot')
    //src: starling/src/tags/comments/canvas-comment.html
riot.tag2('canvas-comment',
  '<button class=" comment_pointer draggable-comment Button Button--Primary Button--Faded Button--Icon Button--Round " data-comment-id="{instance.id}" data-move-enabled="true" onclick="{toggleComment}" ondblclick="{ignoreDblClick}"> <span if="{this.getCount() > 1}" class="comment_pointer_count"> {getCount()} </span> <svg class="Button__Icon"> <use xlink:href="#mode-comment-icon"></use> </svg> </button> <popover if="{isShownComment()}" size="XLarge" position="right" closable="{false}" type="blueish" visible="{true}"> <comment canvas="{parent.canvas}" instance="{parent.instance}" size="small"></comment> </popover>',
  '',
  'class="canvas-comment hideWhenPresenting" riot-style="{getStyle()}" onclick="{handleCommentClick}" ondblclick="{handleCommentClick}" oncontextmenu="{handleRightClick}" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}"', function(opts) {
'use strict';

var _this = this;

var _commentsUi = require('lib/comments-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas,
    instance = _opts.instance;

Object.assign(this, { canvas: canvas, instance: instance });

canvas.canvasCommentTags[instance.id] = this;

this.handleMouseEnter = function (e) {
  _commentsUi.commentsUI.highlightCommentContent(instance.id);
};

this.handleMouseLeave = function (e) {
  _commentsUi.commentsUI.unhighlightCommentContent();
};

this.isShownComment = function () {
  return _commentsUi.commentsUI.isShownComment(instance.id);
};

this.getStyle = function () {
  var pos = instance.getPosition();
  return 'left: ' + pos.x + 'px; top: ' + pos.y + 'px;';
};

this.updatePosition = function () {
  var instance = _this.instance,
      root = _this.root;

  if (instance.getTarget() === 'map' || instance.getTarget() === 'selection') {
    var comment = canvas.store.getComment(instance.id);
    var pos = comment.getPosition();

    root.parentNode.style.left = 'left: ' + pos.x + 'px;';
    root.parentNode.style.top = 'top: ' + pos.y + 'px;';
  }
};

this.toggleComment = function () {
  if (_this.dragging) return;

  if (_this.isShownComment()) {
    _this.dismiss();
    _eventTracking2.default.track({
      category: 'Comment-Action',
      action: 'Toggle-Map-Comment',
      label: 'Hide-Map-Comment'
    });
  } else {
    _this.show();
    _eventTracking2.default.track({
      category: 'Comment-Action',
      action: 'Toggle-Map-Comment',
      label: 'Show-Map-Comment'
    });
  }
};

this.dismiss = function () {
  if (_this.isShownComment()) {
    _this.tags.popover.tags.comment.newCommentInput.save();
    _commentsUi.commentsUI.hideComment(instance.id);
  }

  _this.update();
};

this.show = function () {
  _commentsUi.commentsUI.showComment(instance.id);
  _this.update();
};

this.ignoreDblClick = function (event) {
  event.stopPropagation();
  event.preventDefault();
};

this.onMoveStart = function (e) {
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;
  _commentsUi.commentsUI.resetDragData();
  _commentsUi.commentsUI.setPrevCommentPosition(instance);
};

this.onMove = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy;

  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  var instance = _this.instance;

  _this.dragging = true;
  dx = dx / scale;
  dy = dy / scale;

  _commentsUi.commentsUI.applyMove({ dx: dx, dy: dy, draggingComment: instance });
  _this.update();
};

this.onMoveEnd = function (e) {
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;
  setTimeout(function () {
    // don't trigger a click
    delete _this.dragging;
  }, 400);
  e.stopPropagation();
  var operationMessages = [];
  var message = _commentsUi.commentsUI.getCommentPositionOperationMessage(instance);
  operationMessages.push(message);

  canvas.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.log('Comment move batchOperation failure: ' + err);
    }
  });

  _commentsUi.commentsUI.resetDragData();
  if (_this.dragging) {
    _eventTracking2.default.track({
      category: 'Comment-Action',
      action: 'Comment-Drag',
      label: 'Comment-Drag'
    });
  }
};

this.updateReplies = function () {
  if (!_this || !_this.tags || !_this.tags.comment) return;
  var form = _this.tags.comment.tags['new-comment-input'];

  _this.update();

  if (form) {
    form.update();
  }
};

this.getCount = function () {
  var count = instance.getReplyCount() + 1;
  if (count > 99) return 99;
  return count;
};

this.handleRightClick = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};

this.handleCommentClick = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('canvas-comment')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/canvas-comment.html
// module id = 778
// module chunks = 0